import { Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';


@Component({

  selector: 'app-taxilon-support',

  templateUrl: './taxilon-support.component.html',

  styleUrls: ['./taxilon-support.component.css']

})

export class TaxilonSupportComponent implements OnInit {

  lst_Ticket = [];

  lst_Search = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getTickets()

  }

  filter_Result(strValue: string) {

    this.lst_Ticket = this.lst_Search.filter((el: any) => {

      return el?.iTaxiLon_Tiket.toString().includes(strValue) ||

        el?.strTiketStatus_strComment.toString().includes(strValue) ||

        el?.strName.toString().includes(strValue) ||

        el?.strFamily.toString().includes(strValue) ||

        el?.strMobile.toString().includes(strValue) ||

        el?.strTiketSubject_strComment.toString().includes(strValue)

    });

    if (strValue.trim() == '') {

      this.lst_Ticket = this.lst_Search;

    }

  }

  getTickets = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_Tiket_ORG_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Ticket = res;

    this.lst_Search = res;

  }

}
